import { createFileRoute } from "@tanstack/react-router"
import { NewChat } from "@/features/chat/new-chat"

interface NewChatSearch {
  agent?: number
}

export const Route = createFileRoute("/_app/chat/")({
  staticData: { titleKey: "nav.items.newChat" },
  validateSearch: (s: Record<string, unknown>): NewChatSearch => {
    const agent = Number(s.agent)
    return Number.isFinite(agent) && agent > 0 ? { agent } : {}
  },
  component: NewChatPage,
})

function NewChatPage() {
  const { agent } = Route.useSearch()
  return (
    <div className="h-full">
      <NewChat key={agent ?? "default"} initialAgentId={agent} />
    </div>
  )
}
